<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm align-items-center text-sm d-flex justify-content-between catalogo-text"
          >
            Registrar Cultivo
            <router-link :to="{ name: 'Cultivos' }">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
            </router-link>
          </CCardHeader>
          <!-- v-model="nombreCultivo" -->
          <CCardBody v-if="isLoadingPage">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>
          <CCardBody v-else>
            <CRow>
              <CCol sm="6" md="6" lg="6">
                <CSelect
                  :value.sync="$v.nombreCultivo.$model"
                  :isValid="checkIfValid('nombreCultivo')"
                  label="Nombre del cultivo:"
                  placeholder="Nombre..."
                  invalidFeedback="Campo requerido, debe seleccionar una opción"
                  :options="cultivos"
                />
              </CCol>
              <CCol sm="6" md="6" lg="6">
                <CInput
                  :value.sync="$v.variedad.$model"
                  :isValid="checkIfValid('variedad')"
                  label="Variedad:"
                  placeholder="Variedad..."
                  invalidFeedback="Campo requerido, debe tener al menos 3 caracteres y maximo 25 caracteres"
                />
              </CCol>
            </CRow>
            <hr class="my-4 line" />
            <CRow class="mb-3">
              <CCol md="4" lg="4">
                <CSelect
                  :key="embalajeKey"
                  :value.sync="$v.nombre.$model"
                  :isValid="checkIfValid('nombre')"
                  placeholder="Embalaje..."
                  invalidFeedback="Campo requerido, debe seleccionar una opción"
                  :options="embalajesPorCultivo"
                />
              </CCol>
              <CCol md="3" lg="3">
                <CInput
                  :isValid="checkIfValid('equivalencia')"
                  :value.sync="$v.equivalencia.$model"
                  type="number"
                  placeholder="Equivalencia"
                  invalidFeedback="Campo requerido, debe ser un numero"
                ></CInput>
              </CCol>
              <CCol md="3" lg="3">
                <CSelect
                  :value.sync="embalajeTipo"
                  :options="['kilos', 'piezas']"
                />
              </CCol>
              <CCol alignHorizontal="end" md="2" lg="2">
                <CButton
                  @click="addEmbalaje()"
                  class="float-right"
                  color="success"
                  square
                  >Agregar</CButton
                >
              </CCol>
            </CRow>

            <CDataTable
              hover
              sorter
              bordered
              small
              fixed
              :items="embalajes"
              :fields="fieldsModal"
            >
              <template #tipo="{item}">
                <td>
                  {{ item.tipo }}
                </td>
              </template>
              <template #cancel="{index}">
                <td class="py-2">
                  <CButton
                    color="danger"
                    square
                    size="sm"
                    @click="deleteEmbalaje(index)"
                    >Borrar</CButton
                  >
                </td>
              </template>
            </CDataTable>
            <hr v-if="false" class="my-4 line" />
            <CRow v-if="false" class="mb-3">
              <CCol md="10" lg="10">
                <CInput
                  :isValid="checkIfValid('nombreEtapa')"
                  :value.sync="$v.nombreEtapa.$model"
                  v-model="nombreEtapa"
                  placeholder="Etapa..."
                  invalidFeedback="Campo requerido, debe tener al menos 3 caracteres y maximo 25 caracteres"
                ></CInput>
              </CCol>

              <CCol alignHorizontal="end" md="2" lg="2">
                <CButton
                  class="float-right"
                  @click="addEtapa()"
                  color="success"
                  square
                  >Agregar</CButton
                >
              </CCol>
            </CRow>

            <CDataTable v-if="false"
              hover
              sorter
              bordered
              small
              fixed
              :items="etapas"
              :fields="fieldsModal2"
            >
              <template #nombre="{item}">
                <td class="py-2">{{ item }}</td>
              </template>
              <template #cancel="{index}">
                <td class="py-2">
                  <CButton
                    color="danger"
                    square
                    size="sm"
                    @click="deleteEtapa(index)"
                    >Borrar</CButton
                  >
                </td>
              </template>
            </CDataTable>
            <CRow>
              <CCol sm="9" md="9" lg="9">
                <CAlert
                  fade
                  color="success"
                  class="my-1"
                  :show.sync="currentAlertCounter"
                  >Guardado con éxito.</CAlert
                >
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Cultivos' }">
              <CButton class="px-4 mx-3 btn-lg" color="danger"
                >Cancelar</CButton
              >
            </router-link>
            <!-- <router-link :to="{ name: 'Cultivos' }"> -->
            <CButton
              @click="addCultivo()"
              class="px-4 mx-3 btn-lg"
              color="success"
            >
              <div v-if="isLoading">
                <div
                  class="w-100 d-flex justify-content-center align-items-center"
                >
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
              <span v-else>Guardar</span>
            </CButton>
            <!-- </router-link> -->
          </CCardFooter>
        </CCard>
      </CCol>

      <CModal
        size="sm"
        title="Cultivo"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
        >{{ error }}</CModal
      >
    </CRow>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

const fieldsModal = [
  { key: "nombre", _style: "width:40%" },
  { key: "equivalencia", label: "Equivalencia", _style: "width:40%" },
  { key: "tipo", label: "Tipo", _style: "width:40%" },
  {
    key: "cancel",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  }
];
const fieldsModal2 = [
  { key: "nombre", label: "Etapas", _style: "width:40%" },
  {
    key: "cancel",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  }
];

export default {
  name: "NuevoCultivo",

  data() {
    return {
      nombreCultivo: "",
      variedad: '',
      nombre: "",
      equivalencia: "",
      embalajeTipo: "kilos",
      embalajes: [],
      etapas: [],
      noEmbalajes: {
        noResults: "No hay embalajes",
        noItems: "No hay embalajes"
      },
      nombreEtapa: "",
      fieldsModal,
      fieldsModal2,
      warningModal: false,
      isLoading: false,
      isLoadingPage: true,
      currentAlertCounter: 0,
      details: [],
      error: "",
      submitted: false,
      itemModal: { id: "", name: "" },
      configuracion: [],
      embalajeKey: 0
    };
  },

  mixins: [validationMixin],
  validations: {
    nombreCultivo: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(25)
    },
    variedad: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(25)
    },
    nombre: {
      required,
      // minLength: minLength(3),
      // maxLength: maxLength(25)
    },
    equivalencia: {
      required
    },
    nombreEtapa: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(25)
    }
  },
  created() {
    this.isLoadingPage = true;

    this.$store.dispatch('customHTTP', {
      schema: 'configuracion',
      filter: {
        where: [{field: 'payload->parametro', value: 'cultivos', operator: '='}]
      }
    }).then((configuracion) => {
      this.configuracion = configuracion.data[0].payload.valor
    }).finally(() => (this.isLoadingPage = false));
  },

  computed: {
    //  formString() {
    //    return JSON.stringify(this.form, null, 4);
    //  },
    cultivos() {
      return this.configuracion.map(cultivo => {
        return cultivo.nombre
      })
    },
    embalajesPorCultivo() {
      const cultivo = this.configuracion.find(cultivo => {
        return cultivo.nombre === this.nombreCultivo
      })
      return cultivo ? cultivo.embalajes : []
    },
    isValidCultivo() {
      return !this.$v.nombreCultivo.$invalid && !this.$v.variedad.$invalid ;
    },
    isValidNombre() {
      return !this.$v.nombre.$invalid;
    },
    isValidEquivalencia() {
      return !this.$v.equivalencia.$invalid;
    },
    isValidEtapa() {
      return !this.$v.nombreEtapa.$invalid;
    }
    //  isDirty() {
    //    return this.$v.form.$anyDirty;
    //  }
  },
  watch: {
    nombreCultivo: function() {
      this.nombre = ''
      this.embalajeKey += 1
    },
  },
  methods: {
    addEmbalaje() {
      this.validateEmbalaje();

      if (this.isValidNombre && this.isValidEquivalencia) {
        this.embalajes.push({
          nombre: this.nombre,
          equivalencia: Number(this.equivalencia),
          tipo: this.embalajeTipo
        });
        this.resetEmbalaje();
      }
      // this.nombre = "";
      // this.equivalencia = "";
    },
    addEtapa() {
      this.validateEtapa();
      if (this.isValidEtapa) {
        this.etapas.push(this.nombreEtapa);
        this.resetEtapa();
      }
    },
    deleteEmbalaje(index) {
      if (index !== -1) {
        this.embalajes.splice(index, 1);
      }
    },
    deleteEtapa(index) {
      if (index !== -1) {
        this.etapas.splice(index, 1);
      }
    },
    addCultivo() {
      this.validateCultivo();
      if (this.isValidCultivo) {
        this.isLoading = true;
        this.$store
          .dispatch("customActualizarHTTP", {
            schema: "cultivos",
            payload: {
              nombre: this.nombreCultivo,
              variedad: this.variedad,
              embalajes: this.embalajes,
              etapas: this.etapas
            }
          })
          .then(() => {
            // console.log(res.data);
            this.currentAlertCounter = 6;
            // this.$router.push({ name: "Cultivos" });
          })
          .catch(rej => {
            // console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
          })

          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },

    validateEmbalaje() {
      this.$v.nombre.$touch();
      this.$v.equivalencia.$touch();
    },
    validateEtapa() {
      this.$v.nombreEtapa.$touch();
    },
    validateCultivo() {
      this.$v.nombreCultivo.$touch();
      this.$v.variedad.$touch();
    },

    resetEmbalaje() {
      this.nombre = "";
      this.equivalencia = "";
      this.$v.nombre.$reset();
      this.$v.equivalencia.$reset();
      this.embalajeKey += 1
    },
    resetEtapa() {
      this.nombreEtapa = "";
      this.$v.nombreEtapa.$reset();
    }

    // getEmptyForm() {
    //   return {
    //     cultivoNombre: ""
    //   };
    // }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
>>> .form-control.is-valid,
.form-control.invalid {
  background-image: none;
}
</style>
